module.exports = __webpack_public_path__ + "img/qx.4a25665a.png";